import { useContextBarAppearance } from "@/contexts/ContextBarAppearanceContext";
import DisplayAttachment from "@/domain/entities/emails/DisplayAttachment";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import { Button } from "../../ui/button";

interface AttachmentItemProps {
    attachment: DisplayAttachment;
    icon: ReactNode;
    onPreviewOpen?: () => void;
}

const AttachmentItem = ({
    attachment,
    icon,
    onPreviewOpen,
}: AttachmentItemProps) => {
    const { name } = attachment;
    const { isDeepFocus } = useContextBarAppearance();

    return (
        <Button
            className={cn(
                "flex h-auto w-full whitespace-normal break-words px-3 py-2 text-start text-text-main hover:bg-surface-primaryHover [&_>div]:w-full [&_svg]:size-6",
                isDeepFocus && "text-white hover:bg-white/10",
            )}
            icon={icon}
            onClick={onPreviewOpen}
            variant="invisible"
        >
            {name}
        </Button>
    );
};

export default AttachmentItem;
